import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWufooRegularIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 32 32",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#D46A59",
			d: "M1 16.5a15 15 0 1 0 0-1z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#D04F41",
			d: "M27.6 16a11.6 11.6 0 1 1-23.2 0 11.6 11.6 0 0 1 23.2 0"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M11 25.3 3.8 11l5-1.6 3.8 8.6.5-9.2 4.2-.8 4 8.4.3-9.2 4.4-1-1.2 16.4-4.6 1-4-8.3-.5 9.1z"
		})
	]
});
export default SvgWufooRegularIcon;
